export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;
export const ALLOWED_EXTENSIONS = ['pdf', 'docx', 'txt', 'md', 'markdown'] as const;
export const ACCEPT_ATTR = '.pdf,.docx,.txt,.md,.markdown';

export interface RejectedFile {
  name: string;
  reason: string;
}

export function validateFiles(files: File[]): { valid: File[]; rejected: RejectedFile[] } {
  const valid: File[] = [];
  const rejected: RejectedFile[] = [];
  for (const file of files) {
    const ext = file.name.toLowerCase().split('.').pop() ?? '';
    if (!(ALLOWED_EXTENSIONS as readonly string[]).includes(ext)) {
      rejected.push({ name: file.name, reason: 'unsupported type (allowed: PDF, DOCX, TXT, MD)' });
    } else if (file.size === 0) {
      rejected.push({ name: file.name, reason: 'file is empty' });
    } else if (file.size > MAX_FILE_SIZE_BYTES) {
      rejected.push({ name: file.name, reason: 'larger than 20 MB' });
    } else {
      valid.push(file);
    }
  }
  return { valid, rejected };
}

export function hasFiles(dt: DataTransfer | null): boolean {
  return !!dt && Array.from(dt.types ?? []).includes('Files');
}
